import React, { useState } from "react";
import HeroTitle from "../components/HeroTitle";
import FAQ from "../components/FAQ";

const Faq = () => {
  const [faqs, setFaqs] = useState([
    {
      question: "Do you offer a Done-For-You setup?",
      answer:
        "Yes! We now offer a Done-For-You setup option where you'll get access to a VPS preloaded with NinjaTrader, all of our strategies, settings, and tools — no technical setup needed. Just log in and start trading.",
      open: true,
    },
    {
      question: "Can your algos be used with funded trader programs?",
      answer:
        "Absolutely. Our systems work great with most funded trader programs that allow automated trading. With the ZTAMoneyManager add-on, you can enforce max daily loss, stop trading after drawdowns, and stay within prop firm rules — making it easier to pass and stay funded.",
      open: false,
    },
    {
      question:
        "What is the minimum amount of capital required to successfully trade your algos?",
      answer:
        "A live cash account minimum of $10,000 is best suited to trade our portfolio of strategies on micro futures contracts, and $100,000 if trading E-mini contracts.",
      open: false,
    },
    {
      question: "What platforms do you support?",
      answer:
        "As of now, all of our algos are designed to work exclusively with the NinjaTrader 8 platform. We have plans to build systems for TradeStation and others soon.",
      open: false,
    },
    {
      question: "How do I run these algos?",
      answer:
        "Easy — you import the provided ZIP file into NinjaTrader, apply the included strategy templates, and you're ready to go. We strongly recommend running them on a VPS for 24/7 uptime.",
      open: false,
    },
    {
      question: "What happens after checkout?",
      answer:
        "We ask for your NinjaTrader Machine ID during checkout. Once received, we license your setup within 24 hours (usually faster). You'll get a full onboarding email with all download links and setup instructions.",
      open: false,
    },
    {
      question: "Do I get updates or improvements to the strategies?",
      answer:
        "Yes. While we don't believe in constant tinkering, if we release updates, bug fixes, or improvements, you'll be grandfathered in and receive access at no extra cost.",
      open: false,
    },
    {
      question: "What are my system requirements to run your algos?",
      answer:
        "We recommend an up-to-date version of NinjaTrader 8. You can run the strategies on your personal PC or a VPS (virtual private server) hosted by any provider of your choice.",
      open: false,
    },
    {
      question: "Do you offer support or help if I get stuck?",
      answer:
        "Yes — once you're a client, you'll get access to our private Discord where you can ask questions, get support, and interact directly with the founder and other traders.",
      open: false,
    },
    {
      question: "Can I turn my own strategy idea into an algo?",
      answer:
        "Not at this time. Our team is fully focused on building and improving the ZTA portfolio. However, feel free to reach out if you have a compelling idea — we're always open to exploring good fits.",
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  return (
    <div>
      {/*<HeroTitle title='Frequently Asked Questions' subtitle=''>Frequently Asked Questions</HeroTitle>*/}
      <div
        className="w-full blur-[160px] h-72 absolute mt-[120px]
            bg-gradient-to-b from-blue-500/20 to-cyan-600/30 -z-20"
      ></div>
      <div className="pt-[20px] pb-[60px] text-center">
        <h1
          className="md:mt-2 mb-1 pr-2 pb-[20px] font-bold tracking-tight
                      bg-gradient-to-tl from-blue-200 to-slate-300
                      text-transparent bg-clip-text text-7xl lg:text-8xl md:mb-6"
        >
          Frequently Asked <br />
          Questions
        </h1>
      </div>

      <div
        className="w-full blur-[200px] rounded-full h-72 absolute mt-[600px]
            bg-gradient-to-b from-blue-600/10 to-sky-600/10 -z-20"
      ></div>
      <div className="faqs">
        {faqs.map((faq, index) => (
          <FAQ faq={faq} index={index} key={index} toggleFAQ={toggleFAQ} />
        ))}
      </div>
    </div>
  );
};

export default Faq;
